module.exports = __webpack_public_path__ + "img/product_29.20facc8.webp";